import { LocalService } from "src/app/services/local.service";
import { AuswahlAnzeigeAllgemein } from "./auswahl-anzeige-allgemein.model";
import { ErgebnisQuelleStall } from "./ergebnis-quelle-stall.model";

export class AuswahlAnzeigeStallquelle extends AuswahlAnzeigeAllgemein {
  tierart: string;
  tierkategorie: string;
  haltungsverfahren: string;
  anzahlTiere: number;
  einzeltiermasseGv: number;
  gesamttiermasseGv: number;
  emissionsfaktorGeGv: number;
  emissionsminderungsmassnahme: string;
  wirkungsgrad: number;

  constructor(ergebnisQuelleStall: ErgebnisQuelleStall,
    localService: LocalService) {
    super(ergebnisQuelleStall);


    this.tierart = localService.tierartList.value.filter(
      (item) => item.idTierart == ergebnisQuelleStall.idTierart
    )[0].tierart;

    this.tierkategorie = localService.tierkategorieList.value.filter(
      (item) => item.idTierkategorie == ergebnisQuelleStall.idTierkategorie
    )[0].tierkategorie;

    this.haltungsverfahren = localService.tkHvGeruchsemissionList.value.filter(
      (item) => item.idTkHvGeruchsemissionZuord == ergebnisQuelleStall.idTkHvGeruchsemissionZuord
    )[0].haltungsverfahrenFaktor;

    this.anzahlTiere = ergebnisQuelleStall.anzahlTiere;
    this.einzeltiermasseGv = ergebnisQuelleStall.einzeltiermasseGv;
    this.gesamttiermasseGv = ergebnisQuelleStall.gesamttiermasseGv;
    this.emissionsfaktorGeGv = ergebnisQuelleStall.emissionsfaktorGeGv;
    this.emissionsminderungsmassnahme = localService.minderungsmassnahmeTierkategorieList.value.filter(
      (item) => item.idMmTierartenZuord == ergebnisQuelleStall.idMmTierartenZuord
    )[0].minderungsmassnahmeWirkungsgrad;
    this.wirkungsgrad = ergebnisQuelleStall.wirkungsgrad;
  }
}